export const errorMessages = {
  SOMETHING_WENT_WRONG: "Something went wrong, please try again later.",
};
